import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const fetchProducts = async () => {
  const response = await axios.get(`${API_URL}/products`);
  return response.data;
};

export const fetchProductsByCategory = async (category) => {
  const response = await axios.get(`${API_URL}/products/category/${category}`);
  return response.data;
};

export const saveCart = async (sessionId, items) => {
  const response = await axios.post(`${API_URL}/cart`, { sessionId, items });
  return response.data;
};

export const getCart = async (sessionId) => {
  try {
    const response = await axios.get(`${API_URL}/cart/${sessionId}`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const createOrder = async (sessionId, items, totalPrice, customerPhone = null) => {
  const response = await axios.post(`${API_URL}/orders`, {
    sessionId,
    items,
    totalPrice,
    customerPhone
  });
  return response.data;
};
